/**
 * List of supported MIME types for images uploaded to the backend.
 * @see {@link https://github.com/Timely/timely/blob/8c696381a8038c3786d1690e0e29669d587f2e92/app/models/account.rb#L107}
 */
export const IMAGE_SUPPORTED_MIME_TYPES = ['image/jpg', 'image/jpeg', 'image/pjpeg', 'image/png'];

/**
 * Maximum file size of images uploaded to the backend.
 * @see {@link https://github.com/Timely/timely/blob/8c696381a8038c3786d1690e0e29669d587f2e92/app/models/account.rb#L101}
 */
export const IMAGE_MAX_FILE_SIZE = 2 * 1024 * 1024;

/**
 * Acceps a File from a file upload dialog/drag'n'drop and converts its contents to a data URL.
 */
export const readFileAsDataURL = async (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => resolve(reader.result as string));
    reader.addEventListener('error', () => reject());
    reader.readAsDataURL(file);
  });
};

/**
 * Returns true if the argument is a File that passes the backend image upload constraints.
 * If invalid, it will return a description of the first unmet constraint.
 */
export const isValidImageFile = (imageFile: File): string | true => {
  if (!IMAGE_SUPPORTED_MIME_TYPES.includes(imageFile.type)) {
    return `The file type of your image is not supported. Valid types are JPEG and PNG.`;
  }

  if (imageFile.size >= IMAGE_MAX_FILE_SIZE) {
    return `The image you provided is too large. Max file size is 2 MiB.`;
  }

  return true;
};

/**
 * Extracts the data part from a potential data URL.
 * Returns null if the passed URL isn't a data URL.
 */
export const extractDataFromDataURL = (maybeDataUrl: string) => {
  const mimeTypePart = /^data:(?:[-\w.]+\/[-\w.]+);base64,/i.exec(maybeDataUrl);
  if (!mimeTypePart) return null;
  return maybeDataUrl.replace(mimeTypePart[0], '');
};
